import { useContext } from 'react';
import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { KickOffContext } from '../ModalKickOff';

const GuidelinesStep = () => {
  const { currentTaxYearStr } = useContext(KickOffContext);

  const guidelines = [
    `Confirm all payroll for tax year ${currentTaxYearStr} is processed.`,
    'Customize your P60 issue date.',
    '🚀 Get Your Payroll Ready for the New Tax Year – Fresh Updates, Smooth Compliance! 💰🎉',
  ];

  return (
    <>
      <div
        style={{
          padding: 12,
          backgroundColor: 'rgba(0, 121, 91, 0.1)',
          borderRadius: 10,
        }}
      >
        <div
          style={{
            color: '#00795B',
            fontSize: '1.3rem',
            marginBottom: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <InfoCircleOutlined /> Guidelines
        </div>
        <ul>
          {guidelines.map((item, index) => (
            <li key={index} style={{ color: '#00795B' }}>
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div style={{ marginTop: 12, marginBottom: 32 }}>
        ✅ Once you're done, your payroll system will be all set for the new tax
        year—so you can keep running payroll like a pro! 🎉 Need more details?
        Check out{' '}
        <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          the Year-End Guide!
        </span>
        {' '}📖✨
      </div>
      <div
        style={{
          padding: 12,
          backgroundColor: '#FF9F4329',
          borderRadius: 10,
          display: 'flex',
          gap: 16,
        }}
      >
        <div
          style={{
            padding: 4,
            backgroundColor: '#FF9F43',
            borderRadius: 5,
            height: 'fit-content',
            display: 'flex',
          }}
        >
          <WarningOutlined style={{ color: 'white' }} />
        </div>
        <div style={{ color: '#FF9F43' }}>
          🔔 Before you move forward, make sure all payrolls for the current tax
          year are wrapped up and good to go! ✅🎉
        </div>
      </div>
    </>
  );
};

export default GuidelinesStep;
